import React from 'react';
import { motion } from 'framer-motion';
import { TEAM_AVATARS } from './teamAvatars';

/* Universal Rachel greeting — same Rachel, different context. Used across Kitxens OS workspaces. */
export const RachelGreeting = ({ isEs, name, msgEs, msgEn, accent = '#F77F11', testid = 'rachel-greeting', compact = false, chips = null, cta = null, titleOverride = null, eyebrowOverride = null }) => {
  const rachel = TEAM_AVATARS.find((a) => a.key === 'rachel');
  const h = new Date().getHours();
  const greet = h < 12 ? (isEs ? 'Buenos días' : 'Good morning') : h < 18 ? (isEs ? 'Buenas tardes' : 'Good afternoon') : (isEs ? 'Buenas noches' : 'Good evening');
  return (
    <div data-testid={testid}>
      {!compact && (
        <div className="flex flex-wrap items-start justify-between gap-4">
          <div>
            <p className="text-[11px] uppercase tracking-[0.2em] text-gray-400 font-bold">
              {eyebrowOverride || new Date().toLocaleDateString(isEs ? 'es-ES' : 'en-US', { weekday: 'long', month: 'long', day: 'numeric' })}
            </p>
            <h1 className="mt-1 text-[26px] lg:text-[30px] font-semibold tracking-tight text-gray-900" data-testid={`${testid}-title`}>
              {titleOverride || `${greet}${name ? `, ${name.split(' ')[0]}` : ''}`}
            </h1>
          </div>
          {chips && <div className="flex flex-wrap items-center gap-2 pt-1" data-testid={`${testid}-chips`}>{chips}</div>}
        </div>
      )}
      <motion.div initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5, delay: 0.08 }}
        className="mt-4 rounded-2xl bg-[#1A1A1A] p-5 flex items-start gap-4" data-testid={`${testid}-rachel`}>
        {rachel && <img src={rachel.img} alt="Rachel" className="w-11 h-11 rounded-full object-cover border-2 border-white/20 shrink-0" />}
        <div className="min-w-0">
          <p className="text-[10px] uppercase tracking-[0.2em] font-bold" style={{ color: accent }}>Rachel · AI Concierge</p>
          <p className="mt-1 text-[14px] text-white leading-relaxed">{isEs ? msgEs : msgEn}</p>
          {cta && (
            <a href={cta.to} data-testid={`${testid}-cta`}
              className="mt-2.5 inline-flex items-center gap-1.5 rounded-full bg-white/15 hover:bg-white/25 px-3.5 py-1.5 text-[12px] font-bold text-white transition-colors">
              💬 {cta.label}
            </a>
          )}
        </div>
      </motion.div>
    </div>
  );
};
